import { workersServiceAPI } from '..';

export const getPresignedUrl = async (payload: GetPresignedUrl.Payload): Promise<GetPresignedUrl.Response> => {
  try {
    const response = await workersServiceAPI.post('/api/s3/presign-upload-url', payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
